import React from 'react';
import clsx from 'clsx';
import { formatCurrency } from 'utils';
import { Theme } from '@mui/material/styles';
import { indigo } from '@mui/material/colors';
import { Box, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Pricing } from '../../../types';

interface Props {
  isSelected?: boolean;
  isCalculating: boolean;
  paymentOption: Pricing;
  onSelectOption: VoidFunction;
}

export const PaymentOptionCard = ({ paymentOption, isSelected = false, isCalculating, onSelectOption }: Props) => {
  const classes = useStyles({ isSelected });

  return (
    <Box className={clsx(classes.card, { [classes.cardCalculating]: isCalculating })} onClick={onSelectOption}>
      <Typography className={classes.term} component="span" variant="h6">
        for {paymentOption.term} months
      </Typography>

      <Typography component="span" variant="h5">
        {formatCurrency(paymentOption.paymentAmountPerPeriod)}/mo.
      </Typography>
    </Box>
  );
};

const useStyles = makeStyles<Theme, { isSelected: boolean }>({
  card: {
    gap: '8px',
    display: 'flex',
    padding: '12px',
    maxHeight: '92px',
    flex: '1 1 200px',
    borderRadius: '4px',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    transition: 'all 0.3s ease',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
    backgroundColor: ({ isSelected }) => (isSelected ? indigo['100'] : indigo['50']),

    '&:hover': {
      cursor: 'pointer',
      backgroundColor: indigo['100'],
      boxShadow: '0 4px 10px rgba(0, 0, 0, 0.15)',
    },
  },
  cardCalculating: {
    filter: 'blur(2px)',
  },
  term: {
    color: indigo['600'],
  },
});
